/**
 * Istemci tarafi gorsel kucultme.
 *
 * Neden istemcide?
 *  - 12 MP kamera karesi ~5 MB; 1600px JPEG ~250 KB. Yukleme suresi 10 kat kisalir.
 *  - Worker istek boyutu ve Gemini token maliyeti duser.
 *  - Otel wi-fi'si zayifsa fark hissedilir seviyede.
 */
export const MAKS_KENAR = 1600;
export const JPEG_KALITE = 0.85;

export async function kucultVeJpeg(kaynak: Blob, maksKenar = MAKS_KENAR, kalite = JPEG_KALITE): Promise<Blob> {
  const bitmap = await createImageBitmap(kaynak);
  const olcek = Math.min(1, maksKenar / Math.max(bitmap.width, bitmap.height));
  const genislik = Math.round(bitmap.width * olcek);
  const yukseklik = Math.round(bitmap.height * olcek);

  if (typeof OffscreenCanvas !== 'undefined') {
    const tuval = new OffscreenCanvas(genislik, yukseklik);
    const ctx = tuval.getContext('2d')!;
    ctx.drawImage(bitmap, 0, 0, genislik, yukseklik);
    bitmap.close();
    return tuval.convertToBlob({ type: 'image/jpeg', quality: kalite });
  }

  const tuval = document.createElement('canvas');
  tuval.width = genislik;
  tuval.height = yukseklik;
  tuval.getContext('2d')!.drawImage(bitmap, 0, 0, genislik, yukseklik);
  bitmap.close();
  return new Promise((coz) => tuval.toBlob((b) => coz(b!), 'image/jpeg', kalite));
}

/**
 * <video> karesini yakalar.
 *
 * Goruntu henuz gelmemisse `videoWidth` 0'dir; eskiden bu durumda 0x0 bir
 * tuval cizilip BOS bir JPEG yukleniyordu - OCR "okunamadi" diyor, kimse
 * nedenini anlamiyordu. Artik acikca hata veriyoruz.
 */
export async function videodanKare(video: HTMLVideoElement): Promise<Blob> {
  if (!video.videoWidth || !video.videoHeight) {
    throw new Error('KAMERA_HAZIR_DEGIL');
  }
  const tuval = document.createElement('canvas');
  tuval.width = video.videoWidth;
  tuval.height = video.videoHeight;
  tuval.getContext('2d')!.drawImage(video, 0, 0);
  const ham = await new Promise<Blob>((coz) => tuval.toBlob((b) => coz(b!), 'image/jpeg', 0.95));
  return kucultVeJpeg(ham);
}
